import React, { useCallback, useEffect, useState } from 'react'
import useRazorpay from "react-razorpay";
import Backend_API from '../../../api';
import axios from 'axios';
import { encryptandDecrypt } from '../../../utils/EncrytDecryptData';
import useBooking from './useBooking';
import { useHistory } from 'react-router-dom';
import BookingInvitation from "../BookingPage/components/BookingInvitation/BookingInvitation"
import { Button, Container, Grid, Typography, makeStyles } from '@material-ui/core';
import LoadingDialog from "../../../components/LoadingDialog/DialogModal"
import { SunspotLoader } from "react-awesome-loaders";
import useShowbizz from './useShowbizz';
import Summary from './components/Summary';
import bookingIage from "../../../assets/images/wepik-export-20230604062102jrbO.jpeg"

const successMsg = "Please wait while we process your payment. Do not refresh or navigate away from this page until your payment is successfully completed. This may take a few moments. Thank you for your patience."
const errMsg = "Oops! Something went wrong while booking your ticket. We apologize for the inconvenience. Please try again later or contact our customer support for assistance and your refund will initiated soon .Thank you!"
const errMsgRefundFailed = "Oops! Something went wrong while booking your ticket, and we weren't able to automatically refund your payment. Please contact our customer support with your payment reference below so we can process your refund manually. We're sorry for the inconvenience."
const delayedMsg = "Your payment was received and your seat is confirmed at the theatre. We're just finishing up your ticket - it will be emailed/WhatsApped to you shortly. If it doesn't arrive within 15 minutes, please contact support with your payment reference."

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


const useStyles = makeStyles(theme => ({
  container: { height: '100%', paddingTop: theme.spacing(16),
  [theme.breakpoints.down('md')]: {
    width:"100%",
    marginTop: '60px',
    marginBottom:"60px"
  } },
  [theme.breakpoints.down('md')]: {
    root: { height: '100%' },
  }
}));

const MainBooking = (props) => {
  window.scrollTo(0,0)
  const classes = useStyles()
  const history = useHistory()
    const [data,setData] = useState(props?.location?.state)
    const {confirmBooking,isTicketBooked,jsPdfGenerator,handleRefund,handlOrderConfirm,releaseSeatLock} = useBooking(data)
    const [iserrorOcured,setIsErrorOccured] = useState(false)
    const [isConfirmDelayed,setIsConfirmDelayed] = useState(false)
    const [refundFailed,setRefundFailed] = useState(false)
    const [paymentRef,setPaymentRef] = useState('')
    const {bookSeatsShowbizz} = useShowbizz()
    const [isLoading,setIsLoading] = useState(false)

    const encoded = props.location?.search?.split("=")[1]

    const confirmOrder = async(orderID) =>{
      const response = await handlOrderConfirm(orderID)
      if(!response?.data) return  history.goBack()
    }
    
    useEffect(() => {
      if(!encoded) return history.goBack()
        const result = encryptandDecrypt.decrypt(encoded)
        // if the user have done the payment already they wont be allowed in the page
        confirmOrder(result?.orderID)
        setData(result)
    },[props?.location?.search])

    const Razorpay = useRazorpay();

    const handlePayment = useCallback(async (result) => {
      
      try {
          const token = localStorage.getItem('jwtToken');
          const Bookingdata = {...result};
          const orderresponse = await axios({
              method: 'POST',
              url: Backend_API + '/lock/seat?orderId='+result?.orderID,
              data: Bookingdata,
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
              }
            });      

          const options = {
           key: "rzp_live_D9wvDh6h4gIHwg", //live
            // key:"rzp_test_Aa42H5Utk4BHVh",//test
            amount: "100",
            currency: "INR",
            name: 'Innovative Multiplex',
            description: 'Buy Ticket for Movie',
            image: 'https://innovativemultiplex.com/InnovativeMultiplex-Logo.png',
            order_id: result?.orderID,
            handler: async(response) => {
              //process is starting
              setIsLoading(true)
              const returnValue = await bookSeatsShowbizz(result?.convertedSeats,result)

              if(!returnValue){
                // The real seat booking failed after payment - refund and
                // free the seat lock immediately instead of leaving it
                // blocked until the background cleanup job gets to it.
                setPaymentRef(response?.razorpay_payment_id || '')

                let refunded = false;
                for (let attempt = 0; attempt < 3 && !refunded; attempt++) {
                  refunded = await handleRefund(response?.razorpay_payment_id)
                  if (!refunded && attempt < 2) await sleep(1500)
                }
                setRefundFailed(!refunded)

                // Best-effort, not critical if it fails - the background
                // cleanup job will free the seat within a few minutes anyway.
                releaseSeatLock(result?.orderID)

                return setIsErrorOccured(true)
              }

              // Payment succeeded and the seat is already booked at the
              // theatre - retry saving the reservation a few times before
              // giving up, since this step is usually a transient blip and
              // the customer has already paid and has a real seat.
              setPaymentRef(response?.razorpay_payment_id || '')
              let confirmed = false;
              for (let attempt = 0; attempt < 3 && !confirmed; attempt++) {
                confirmed = await confirmBooking(response, result);
                if (!confirmed && attempt < 2) await sleep(1500);
              }

              if (!confirmed) {
                // Don't silently fall back to the "Pay" screen - the
                // customer already paid and the seat is booked. Our
                // background job will still pick this up and email/WhatsApp
                // the ticket, but let them know instead of showing nothing.
                setIsConfirmDelayed(true)
                return
              }

              setIsLoading(false)
            },
            prefill: {
                name: result?.name,
                email: result?.email,
                contact: result?.phone
            },
            notes: {
              address: "Razorpay Corporate Office",
            },
            theme: {
              color: "#3399cc",
            },
          };
      
          const rzpay = new Razorpay(options);
          rzpay.open();
      }catch(error){
        this.props.setAlert(error.response?.data?.error || "Unexpected error", 'error', 5000);
        console.log(error);
      }
    }, [Razorpay]);

  return (
    <Container maxWidth="lg" className={classes.container} style={{marginBottom:"2rem"}} >
      {
        !isTicketBooked &&
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} sm={6} lg={3}  >
          <Summary handlePayment={() => handlePayment(data)} data={data}/>
        </Grid>
        <Grid item xs={0} md={8} lg={9} >
          <div style={{backgroundImage: `url(${bookingIage})`,height:"150px",borderRadius:"8px", backgroundPosition: "center",backgroundSize: "cover",filter: "blur(1px)"
  }}></div>
          {/* <img style={{height:"150px",width:"100%",objectFit:"cover",borderRadius:"8px"}} src={bookingIage} alt="image" /> */}
        </Grid>
      </Grid>
      }
    {/* <button onClick={() =>handlePayment(data)}>Click</button> */}
    {/* if the ticket is in booking process then this happens */}
    <LoadingDialog isOpen={isLoading && !isTicketBooked} >
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",}}>
      <Typography  variant='subtitle1' style={{color:"black",marginBottom:"1rem",textAlign:"center",fontSize:"14px",fontWeight:600}}>{iserrorOcured ? (refundFailed ? errMsgRefundFailed : errMsg) : isConfirmDelayed ? delayedMsg : successMsg}</Typography>
      { (iserrorOcured || isConfirmDelayed) && paymentRef && (
        <Typography variant='caption' style={{color:"black",marginBottom:"1rem",textAlign:"center"}}>Payment reference: {paymentRef}</Typography>
      )}
      { (iserrorOcured || isConfirmDelayed) ?<Button variant='outlined' onClick={() => history.goBack()}>Go Back</Button>
        :<SunspotLoader
    gradientColors={["#6366F1", "#E0E7FF"]}
    shadowColor={"#3730A3"}
    desktopSize={'50px'}
    mobileSize={'30px'}
  />}
    </div>
  </LoadingDialog>
    {
      isTicketBooked &&
      <BookingInvitation data={data} cinema={data?.cinema} onDownloadPDF={jsPdfGenerator} />
    }
    </Container>

  )
}

export default MainBooking